import { styled } from '@mui/material/styles';

export const StyledAnchor = styled('a')`
  text-decoration: none;
  text-transform: none;
`;
